export default {
	state: {
		fullSidePanelMode: false,
	},

	actions: {
		'chatroomConfigModel/setFullSidePanelMode': function (context, data) {
			context.commit('chatroomConfigModel/setFullSidePanelMode', data);
		}
	},

	mutations: {
		'chatroomConfigModel/setFullSidePanelMode': function (state, data) {
			state.fullSidePanelMode = data;
		}
	}

}


// WEBPACK FOOTER //
// ./src/ChatRoom/ChatroomConfigModel.js